"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _store = require('shared/store');





















// The patient table's commands. Nothing stores their answers: the table
// keeps its page in local state and reloads it after each action.

const listOrgPatientsActions = _utils.createAsyncActions('ListOrgPatients')
const getPatientTableRowActions = _utils.createAsyncActions('GetPatientTableRow')
const listPatientTagsActions = _utils.createAsyncActions('ListPatientTags')
const tagPatientsActions = _utils.createAsyncActions('TagPatients')
const untagPatientsActions = _utils.createAsyncActions('UntagPatients')
const previewPatientsForBroadcastActions = _utils.createAsyncActions('PreviewPatientsForBroadcast')
const previewPatientSelectionActions = _utils.createAsyncActions('PreviewPatientSelection')
const addPatientsToBroadcastActions = _utils.createAsyncActions('AddPatientsToBroadcast')
const previewPatientPickForBroadcastActions = _utils.createAsyncActions('PreviewPatientPickForBroadcast')
const addPatientPickToBroadcastActions = _utils.createAsyncActions('AddPatientPickToBroadcast')
const archivePatientsActions = _utils.createAsyncActions('ArchivePatients')
const restorePatientsActions = _utils.createAsyncActions('RestorePatients')
const getPatientArchiveStatusActions = _utils.createAsyncActions('GetPatientArchiveStatus')
const getRunningPatientArchivesActions = _utils.createAsyncActions('GetRunningPatientArchives')
// Dispatched once a background archive or restore has finished, so patient
// lists (the mobile Directory) reload without the archived patients.
const patientArchiveFinishedActions = _utils.createAsyncActions('PatientArchiveFinished')

 const actionCreators = {
  addPatientPickToBroadcastActions,
  patientArchiveFinishedActions,
}; exports.actionCreators = actionCreators

// Adding 20,000 patients to a broadcast waits on the server's chunked write.
const BULK_TTL = 120000

const listOrgPatients = (req) =>
  _helpers.wsCommand('ListOrgPatients', listOrgPatientsActions, req, null)

const getPatientTableRow = (req) =>
  _helpers.wsCommand('GetPatientTableRow', getPatientTableRowActions, req, null)

const listPatientTags = (req) =>
  _helpers.wsCommand('ListPatientTags', listPatientTagsActions, req, null)

const tagPatients = (req) =>
  _helpers.wsCommand('TagPatients', tagPatientsActions, req, null, undefined, BULK_TTL)

const untagPatients = (req) =>
  _helpers.wsCommand('UntagPatients', untagPatientsActions, req, null, undefined, BULK_TTL)

const previewPatientsForBroadcast = (req) =>
  _helpers.wsCommand('PreviewPatientsForBroadcast', previewPatientsForBroadcastActions, req, null, undefined, BULK_TTL)

const previewPatientSelection = (req) =>
  _helpers.wsCommand('PreviewPatientSelection', previewPatientSelectionActions, req, null, undefined, BULK_TTL)

const addPatientsToBroadcast = (req) =>
  _helpers.wsCommand('AddPatientsToBroadcast', addPatientsToBroadcastActions, req, null, undefined, BULK_TTL)

const previewPatientPickForBroadcast = (req) =>
  _helpers.wsCommand('PreviewPatientPickForBroadcast', previewPatientPickForBroadcastActions, req, null, undefined, BULK_TTL)

// The campaign counts as adding (selectIsAddingRecipients) until the reply.
const addPatientPickToBroadcast = (req) =>
  _helpers.wsCommand('AddPatientPickToBroadcast', addPatientPickToBroadcastActions, req, { CampaignKey: req.CampaignKey }, undefined, BULK_TTL)

const archivePatients = (req) =>
  _helpers.wsCommand('ArchivePatients', archivePatientsActions, req, null, undefined, BULK_TTL)

const restorePatients = (req) =>
  _helpers.wsCommand('RestorePatients', restorePatientsActions, req, null, undefined, BULK_TTL)

const getPatientArchiveStatus = (req) =>
  _helpers.wsCommand('GetPatientArchiveStatus', getPatientArchiveStatusActions, req, null)

const getRunningPatientArchives = (req) =>
  _helpers.wsCommand('GetRunningPatientArchives', getRunningPatientArchivesActions, req, null)

const ARCHIVE_POLL_MS = 2000
const ARCHIVE_POLL_LIMIT = 90

/* Waits for a background archive or restore (ArchivePatients,
 * RestorePatients) to finish, checking its status every 2 seconds for up to
 * 3 minutes, and resolves with its final status. */
const waitForPatientArchive = async (OrgKey, TaskKey) => {
  for (let i = 0; i < ARCHIVE_POLL_LIMIT; i++) {
    await new Promise(resolve => setTimeout(resolve, ARCHIVE_POLL_MS))
    const status = await getPatientArchiveStatus({ OrgKey, TaskKey })
    if (status.Stage === 'finished' || status.Stage === 'error') {
      _store.dispatch.call(void 0, patientArchiveFinishedActions.SUCCESS(status, null))
      return status
    }
  }
  throw new Error('The archive is taking longer than expected.')
}

exports. default = {
  listOrgPatients,
  getPatientTableRow,
  listPatientTags,
  tagPatients,
  untagPatients,
  previewPatientsForBroadcast,
  previewPatientSelection,
  addPatientsToBroadcast,
  previewPatientPickForBroadcast,
  addPatientPickToBroadcast,
  archivePatients,
  restorePatients,
  getPatientArchiveStatus,
  getRunningPatientArchives,
  waitForPatientArchive,
}
